import React from "react";
import "./People_Behind_Work.css";
import { FaFacebookF, FaInstagram, FaTwitter } from "react-icons/fa";
import {
  faFacebookF,
  faInstagram,
  faXTwitter,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PeopleBehindWorks } from "../../../utils/apis/aboutus/Aboutus.js";
import { useContext, useEffect, useState } from "react";
import { Context } from "../../../utils/context";
import { IDS } from "../../../utils/common";

const teamMembers = [
  {
    name: "Mrs. Priya Patel",
    role: "Project Manager",
    image: "/assets/images/aboutus/priya.png",
  },
  {
    name: "Mr. Ankit Verma",
    role: "Solar Engineer",
    image: "/assets/images/aboutus/ankit.png",
  },
  {
    name: "Miss. Anvika Roy",
    role: "Customer Support Lead",
    image: "/assets/images/aboutus/avnika.png",
  },
];

const PeopleBehindWork = () => {
  const { IMG_URL } = useContext(Context);

  const [peoplebehindwork, setPeopleBehindWork] = useState([]);

  const getPeopleBehindWork = async () => {
    const res = await PeopleBehindWorks();

    if (res?.success) {
      setPeopleBehindWork(res?.data?.data || []);
    }
  };

  useEffect(() => {
    getPeopleBehindWork();
  }, []);

  return (
    <section className="people_section">
      <div className="container">
        <h2 className="section_title">The People Behind the Work</h2>
        <p className="section_subtitle">
          A group of dedicated minds working together to build something
          meaningful.
        </p>

        <div className="row card_wrapper">
          {peoplebehindwork.map((member, index) => (
            <div
              className="col-12 col-sm-6 col-md-4 col-lg-3  "
              key={index}
              style={{ marginBottom: "30px" }}
            >
              <div className="card">
                <div className="image_wrapper">
                  <img
                    src={IDS?.IMG_URL + member?.image}
                    alt={member.name}
                    className="img_fluid"
                  />
                  <div className="vertical_name">
                    <span>{member.name}</span></div>
                </div>

                <h5 className="role">{member.position}</h5>
                <p className="name">{member.name}</p>

                {/* <div className="social-icons">
                  {[
                    { icon: faFacebookF, link: "https://www.facebook.com" },
                    { icon: faInstagram, link: "https://www.instagram.com" },
                    { icon: faXTwitter, link: "https://www.twitter.com" },
                  ].map((item, index) => (
                    <a
                      key={index}
                      href={item.link}
                      className="social_link"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FontAwesomeIcon
                        icon={item.icon}
                        className="social-icon"
                      />
                    </a>
                  ))}
                </div> */}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PeopleBehindWork;
